import Vue from 'vue';
import VueLoading from 'vue-loading-overlay/src/js/Component';
import 'vue-loading-overlay/dist/vue-loading.css';
import '../../css/house-loader.css';
const install = Vue => {
    Vue.component('loader', {
        props: {
            width: {
                type: Number,
                default: 180
            },
            height: {
                type: Number,
                default: 175
            }
        },
        template: '<v-img id="house-loader" src="/brandingThumbnailLogo" contain :width="width" :height="height" />'
    });

    Vue.component('vue-loading', {
        extends: VueLoading,
        props: {
            loader: {
                type: String,
                default: 'loader'
            }
        }
    })

    Vue.component('housejet-loader', {
        template: '<v-img id="house-loader" src="/brandingThumbnailLogo" contain width="40px" height="40px" style="right: 90px; top: 10px; position: absolute" />',
        data() {
            return {
                loader: 'housejet-loader'
            };
        }
    });
}
Vue.use(install);
